export const ITEMS_SET = "ITEMS::SET"
export const ITEMS_LOADING = "ITEMS::LOADING"
export const ITEMS_UPDATE_ITEM = "ITEMS::ITEM::UPDATE"
export const MY_ITEMS_SET = "ITEMS::SET::MY_ITEMS"
export const MY_ITEMS_LOADING = "ITEMS::LOADING::MY_ITEMS"
